export default __webpack_public_path__ + "static/businessSuccessBg-5f78d6c7176bca47283f299f0d7a36e5.png";